module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(this.promotions) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fadd93d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Data.vue
// module id = 224
// module chunks = 1